import { IOrderSend } from 'src/types/order';
import { OrderFormData } from 'src/screens/General/screens/Orders/components/OrderForm';

export const groupOrder = (dataForm: Partial<OrderFormData>): Partial<IOrderSend> => {
    const {
        studentDropDown,
        serviceTypeDropDown,
        serviceTypeProviderDropDown,
        orderTypeDropDown,
        statusDropDown,
        orderCaseTypeDropDown,
        authorizationSourceDropDown,
        allocatedPeriodDropDown,
        orderSubtypeDropDown,
        allocatedHours,
        allocatedMoney,
        maximumAvailableHours,
        orderReferralSourceDropDown,
        ...data
    } = dataForm;
    const dataSend: Partial<IOrderSend> = { ...data };
    if (studentDropDown) {
        dataSend.student = studentDropDown.value;
    }
    if (orderCaseTypeDropDown) {
        dataSend.orderCaseType = orderCaseTypeDropDown.value;
    }
    if (serviceTypeDropDown) {
        dataSend.serviceType = serviceTypeDropDown.value;
    }

    if (serviceTypeProviderDropDown) {
        dataSend.serviceTypeProvider = serviceTypeProviderDropDown.value;
    }

    if (orderTypeDropDown) {
        dataSend.orderType = orderTypeDropDown.value;
    }

    if (statusDropDown) {
        dataSend.status = statusDropDown.value;
    }

    if (orderReferralSourceDropDown) {
        dataSend.referralSource = orderReferralSourceDropDown.value;
    }

    if (authorizationSourceDropDown) {
        dataSend.authorizationSource = authorizationSourceDropDown.value;
    }
    if (allocatedPeriodDropDown) {
        dataSend.allocatedPeriod = allocatedPeriodDropDown.value;
    }

    if (orderSubtypeDropDown) {
        dataSend.orderSubtype = orderSubtypeDropDown.value;
    }

    if (allocatedHours) {
        dataSend.allocatedHours = parseFloat(allocatedHours);
    }
    if (maximumAvailableHours) {
        dataSend.maximumAvailableHours = parseFloat(`${maximumAvailableHours}`);
    }

    if (allocatedMoney) {
        dataSend.allocatedMoney = parseFloat(allocatedMoney);
    }

    return dataSend;
};
